import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { ModalContentV1, StyledModal, WrapImage } from "./styles";
import {
  Description,
  FeedInformation,
  HeaderContainer,
  ImageWrapper,
  LikeCommentButton,
  LikeCommentButtonSection,
  LikeCommentCount,
  PostCommentsWrapper,
  PostReactionsContainer,
  RecognitionBirthdayAnniversary,
  RecognitionImage,
  RecogntionContainer,
  SliderContainer,
  UserInformation,
  UserInitials,
  UserInitialsMain,
} from "../SocialFeedsV2/styles";
import { closeIcon, CongratulationsEmojiIcon, SocialFeedCommentIcon } from "../../utils/icons";
import { ImageUrl } from "../../utils/constants";
import { convertUnicode, createSafeHTML, getInitials } from "../../utils/methods";
import Slider from "react-slick-16";
import Image from "../Image";
import { useSelector } from "react-redux";
import _ from "lodash";
import { t } from "i18next";
import LazyImage from "../common/LazyImage/LazyImage";

const SocialPostPopup = ({ isOpen, feed, onClose, profileImage }) => {
  const [showmore, setShowMore] = useState(false);
  const [notBase64, setNotBase64] = useState(false);
  //   let hideCommentText = false;

  useEffect(() => {
    checkBase64(profileImage);
  }, []);
  const userId = useSelector((state) => state.profileData.userId);

  if (!isOpen) return null;
  let feedMultiImage = {
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    draggable: true,
    adaptiveHeight: true,
    nextArrow: <div className={"left-arrow slick-next"} />,
    prevArrow: <div className={"left-arrow slick-prev"} />,
    responsive: [
      {
        breakpoint: 1252,
        settings: {
          dots: true,
          infinite: true,
          speed: 500,
          draggable: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          dots: true,
          infinite: true,
          speed: 500,
          draggable: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
        },
      },
    ],
  };

  const showMoreText = () => {
    setShowMore(true);
  };


  const handleClose = () => {
    // Ensure onClose only updates the modal visibility and doesn't affect routing.
    onClose();
  };

  const containsDefaultPng = (str) => {
    const defaultPngFound = str?.includes("default.png");
    return defaultPngFound;
  };

  const checkBase64 = (profileImage) => {
    if (profileImage) {
      let arr = profileImage.split("/");
      if (arr[0] !== "profile-Image") {
        setNotBase64(false);
      } else {
        setNotBase64(true);
      }
    }
  };

  const imgSrc = (isOwn) => {
    // const { userId, feed, profileImage } = this.props;
    // const notBase64 = true;
    // const { notBase64 } = this.state;
    if (isOwn) {
      if (!notBase64) {
        return !containsDefaultPng(profileImage) ? (
          <img src={`${ImageUrl}/${profileImage}`} />
        ) : (
          <UserInitialsMain>{`${getInitials(feed?.fname)}${getInitials(
            feed?.lname
          )}`}</UserInitialsMain>
        );
      } else {
        return !containsDefaultPng(profileImage) ? (
          <Image image={profileImage} />
        ) : (
          <UserInitialsMain>{`${getInitials(feed?.fname)}${getInitials(
            feed?.lname
          )}`}</UserInitialsMain>
        );
      }
    } else if (userId == feed.uid) {
      if (!notBase64) {
        return !containsDefaultPng(profileImage) ? (
          <img src={`${ImageUrl}/${profileImage}`} />
        ) : (
          <UserInitialsMain>{`${getInitials(feed?.fname)}${getInitials(
            feed?.lname
          )}`}</UserInitialsMain>
        );
      } else {
        return !containsDefaultPng(profileImage) ? (
          <Image image={profileImage} />
        ) : (
          <UserInitialsMain>{`${getInitials(feed?.fname)}${getInitials(
            feed?.lname
          )}`}</UserInitialsMain>
        );
      }
    } else {
      return !containsDefaultPng(feed?.profile_image) ? (
        <img src={`${ImageUrl}/${feed?.profile_image}`} />
      ) : (
        <UserInitialsMain>{`${getInitials(feed?.fname)}${getInitials(
          feed?.lname
        )}`}</UserInitialsMain>
      );
    }
  };

  const singleFeedData = _.isEmpty(feed) ? feed : feed;

  return (
    <StyledModal id="social-modal" show={isOpen} onHide={onClose} centered width="1200px">
      <ModalContentV1 id="social-content" isPost isWidth={"1200px"} isPaddingSocial={"0px"}>
        <div  id="social-container" style={{ display: "flex", width: "100%", borderRadius: "6px" }}>
          <div
            style={{
              width: "800px",
              height: "600px",
              backgroundColor: "black",
            }}
          >
            {feed.type_id === 4 || feed.type_id === 5 ?  (
                  
              feed?.post_user_wishes?.length === 1 && (
                <WrapImage
                  noMargin
                  isPadding={false}
                >

                  <RecognitionBirthdayAnniversary
                    id="bithday-anniversary"
                    margin
                    image={
                      feed?.post_template?.bg_image
                    }
                    height="600px"
                  >
                    <div id="main-container" className="mainContainer">
                      <div id="wish" className="wish">
                        {feed?.post_template?.title}
                      </div>
                      <div  id="wish-name" className="wish-name">
                        {feed?.post_user_wishes?.[0]?.user_name}
                      </div>
                      <div id="social-image" className="image">
                        <div  id="social-image-width" className="imageWidth">
                          {feed?.post_user_wishes[0]?.profile_image &&
                      !containsDefaultPng(
                        feed?.post_user_wishes[0]?.profile_image
                      ) ? (
                              <img
                                src={`${ImageUrl}/${feed?.post_user_wishes[0]?.profile_image}`}
                              />
                            ) : (
                              <UserInitials
                                color={feed?.recognition_color_value}
                              >
                                {getInitials(
                                  feed?.post_user_wishes?.[0]?.user_name
                                )}
                              </UserInitials>
                            )}
                        </div>
                      </div>
                      {feed.core_value == "Work Anniversary" ? (
                        <div id="anniversary-message" className="message">
                      Your dedication and hard work have been an
                      inspiration to us <br /> all. Here’s to many more
                      years of success together!
                        </div>
                      ) : (
                        <div id="birthday-message" className="message">
                      May this year bring you continued success and
                      fulfillment in <br />
                      both your personal and professional life.
                        </div>
                      )}
                    </div>
                  </RecognitionBirthdayAnniversary>
                </WrapImage>
              )
            ) 
              : feed.type_id === 3 ?                   
                <RecognitionImage
                  id="core-value=container"
                  margin
                  image={feed?.post_recognitions?.bg_image}
                  height="600px"
                >
                  <div className="mainContainer">
                    <div className="image">
                      <div className="imageWidth">
                        {feed?.recognition_recipients[0]?.profile_image &&
                    !containsDefaultPng(
                      feed?.recognition_recipients[0]?.profile_image
                    ) ? (
                            <img
                              src={`${ImageUrl}/${feed?.recognition_recipients[0]?.profile_image}`}
                            />
                          ) : (
                            <UserInitials
                              color={feed?.post_recognitions?.recognition_color_value}
                            >
                              {getInitials(
                                feed?.recognition_recipients[0]?.recognized_user_name
                              )}
                            </UserInitials>
                          )}
                      </div>
                      <RecogntionContainer
                        border={feed?.post_recognitions?.recognition_color_value}
                      >
                        <div id="recognition-value" className="recogntionvalue">
                          <div className="image">
                            <img
                              src={`${ImageUrl}/${feed?.post_recognitions?.image}`}
                            />
                          </div>
                          <div className="name">{feed?.post_recognitions?.core_value}</div>
                        </div>
                      </RecogntionContainer>
                      <div id="recognition-text" className="recognition">
                        <span className="textRecognition">
                          {"Congratulations to"}
                        </span>
                        &nbsp;
                        <span className="boldRecognition">
                          {feed?.recognition_recipients[0]?.recognized_user_name}
                        </span>
                        &nbsp;
                        {CongratulationsEmojiIcon()}
                      </div>
                    </div>
                  </div>
                </RecognitionImage>
                :                 
                <SliderContainer
                  display="flex"
                  content="center"
                  shadow="0px 8px 25px 0px #0D427040"
                >
                  <Slider {...feedMultiImage}>
                    {
                      feed?.post_images?.map((data, index) => (
                        <WrapImage key={index}>
                          <img
                            src={`${ImageUrl}/${data?.image}`}
                            alt={data?.body}
                          />
                        </WrapImage>
                      ))}
                  </Slider>
                </SliderContainer> }
            {" "}
            {/* {
              feed?.post_images?.length > 2 &&
              feed?.mentioned_users?.length > 2 ? (
                  <SliderContainer
                    display="flex"
                    content="center"
                    shadow="0px 8px 25px 0px #0D427040"
                  >
                    <Slider {...feedMultiImage}>
                      {
                        feed?.post_images?.map((data, index) => (
                          <WrapImage key={index}>
                            <img
                              src={`${ImageUrl}/${data?.image}`}
                              alt={data?.body}
                            />
                          </WrapImage>
                        ))}
                    </Slider>
                  </SliderContainer>
                ) : (
                  
                  feed?.post_images?.length === 1 && (
                    <WrapImage
                      noMargin
                      isPadding={
                        feed.core_value !== "Happy Birthday" &&
                      feed.core_value !== "Work Anniversary"
                      }
                    >
                      {feed.core_value ? (
                        feed.core_value == "Happy Birthday" ||
                        feed.core_value == "Work Anniversary" ? (
                            <RecognitionBirthdayAnniversary
                              id="bithday-anniversary"
                              margin
                              image={
                                feed.core_value == "Work Anniversary"
                                  ? "social-feed/anniversaryCover.svg"
                                  : "social-feed/birthdayCover.svg"
                              }
                              height="600px"
                            >
                              <div id="main-container" className="mainContainer">
                                <div id="wish" className="wish">
                                  {feed.core_value == "Work Anniversary"
                                    ? "Happy Work Anniversary!"
                                    : "Happy Birthday!"}
                                </div>
                                <div  id="wish-name" className="wish-name">
                                  {feed?.mentioned_users[0]?.fullname}
                                </div>
                                <div id="social-image" className="image">
                                  <div  id="social-image-width" className="imageWidth">
                                    {feed?.mentioned_users[0]?.profile_image &&
                                !containsDefaultPng(
                                  feed?.mentioned_users[0]?.profile_image
                                ) ? (
                                        <img
                                          src={`${ImageUrl}/${feed?.mentioned_users[0]?.profile_image}`}
                                        />
                                      ) : (
                                        <UserInitials
                                          color={feed?.recognition_color_value}
                                        >
                                          {getInitials(
                                            feed?.mentioned_users[0]?.fullname
                                          )}
                                        </UserInitials>
                                      )}
                                  </div>
                                </div>
                                {feed.core_value == "Work Anniversary" ? (
                                  <div id="anniversary-message" className="message">
                                Your dedication and hard work have been an
                                inspiration to us <br /> all. Here’s to many more
                                years of success together!
                                  </div>
                                ) : (
                                  <div id="birthday-message" className="message">
                                May this year bring you continued success and
                                fulfillment in <br />
                                both your personal and professional life.
                                  </div>
                                )}
                              </div>
                            </RecognitionBirthdayAnniversary>
                          ) : (
                            <RecognitionImage
                              id="core-value=container"
                              margin
                              image={feed?.bg_image}
                              height="540px"
                            >
                              <div className="mainContainer">
                                <div className="image">
                                  <div className="imageWidth">
                                    {feed?.mentioned_users[0]?.profile_image &&
                                !containsDefaultPng(
                                  feed?.mentioned_users[0]?.profile_image
                                ) ? (
                                        <img
                                          src={`${ImageUrl}/${feed?.mentioned_users[0]?.profile_image}`}
                                        />
                                      ) : (
                                        <UserInitials
                                          color={feed?.recognition_color_value}
                                        >
                                          {getInitials(
                                            feed?.mentioned_users[0]?.fullname
                                          )}
                                        </UserInitials>
                                      )}
                                  </div>
                                  <RecogntionContainer
                                    border={feed?.recognition_color_value}
                                  >
                                    <div id="recognition-value" className="recogntionvalue">
                                      <div className="image">
                                        <img
                                          src={`${ImageUrl}/${feed?.recognition_image}`}
                                        />
                                      </div>
                                      <div className="name">{feed?.core_value}</div>
                                    </div>
                                  </RecogntionContainer>
                                  <div id="recognition-text" className="recognition">
                                    <span className="textRecognition">
                                      {"Congratulations to"}
                                    </span>
                                    &nbsp;
                                    <span className="boldRecognition">
                                      {feed?.mentioned_users[0]?.fullname}
                                    </span>
                                    &nbsp;
                                    {CongratulationsEmojiIcon()}
                                  </div>
                                </div>
                              </div>
                            </RecognitionImage>
                          )
                      ) : null}
                    </WrapImage>
                  )
                )} */}
          </div>
          <div style={{ width: "400px", backgroundColor: "white" }}>
            <div
              id={feed.id}
              key={feed.id + "key"}
              style={{
                background: "white",
                height: "600px",
                borderRadius: "0 6px 6px 0",
              }}
            >
              <HeaderContainer onModal>
                <ImageWrapper display={1} borderRadius={"50%"}>
                  {imgSrc(false)}
                </ImageWrapper>
                <UserInformation isOwnPost={userId == feed.uid}>
                  <div className="name">
                    {feed?.post_owner?.post_owner_name}
                  </div>
                  <div className="time">{feed?.post_location}</div>
                  <div className="time">
                    {feed?.time_ago} |&nbsp;{" "}
                    <img src={ImageUrl + "/social-feed/time.svg"} />
                  </div>
                </UserInformation>
                {
                  <div className="buttondiv">
                    {userId === feed.uid && (
                      <>
                        <div
                          className="closeicon"
                          onClick={() => handleClose()}
                        >
                          {closeIcon()}
                        </div>
                      </>
                    )}
                  </div>
                }

              </HeaderContainer>
              <FeedInformation style={{ height: "502px" }}>
                <PostCommentsWrapper>
                  <div style={{ width: "100%", display: "block" }}>
                    {feed.description != null && feed.description !== "" && (
                      <Description
                        width="true"
                        contents
                        paddingmain="0px"
                        text={showmore ? "" : "60px"}
                      >
                        <div className="truncate">
                          {createSafeHTML(
                            feed.description
                              ? convertUnicode(feed.description)
                                .split("\\n")
                                .join("<br />")
                              : ""
                          )}
                        </div>
                        {!showmore && feed.description?.length > 144 && (
                          <div
                            className="more-text"
                            onClick={() => showMoreText()}
                          >
                            ... more
                          </div>
                        )}
                      </Description>
                    )}
                  </div>
                  {singleFeedData?.post_likes?.length > 0 ? (
                    <LikeCommentCount commentpopup>
                      <div>
                        {singleFeedData?.reactions?.length ?               <PostReactionsContainer>
                          {singleFeedData?.reactions.map((reaction, index) => (
                            <div key={reaction} className='icon-container'
                              style={{    position: "relative",right: index > 0 && "8px"}}>
                              <LazyImage
                                src={ImageUrl+`/social-feed-reactions/${reaction}.png`}
                                alt={reaction}
                                // className={`reaction-icon ${selectedReaction === reaction ? 'selected' : ''}`}
                                // onClick={() => this.handleReactionClick(reaction)}
                                className={"icon"}
             
                              />
                            </div>
                          ))}
                        </PostReactionsContainer> :null}
                        {
                          singleFeedData?.post_likes_count > 0 ?
                            singleFeedData?.post_likes_count === 1 ? (
                              <span id={`like-${singleFeedData.id}-text`} className='simpletext'>&nbsp;{singleFeedData.post_likes[0].liked_by}</span>
                            ) : (
                              singleFeedData?.post_likes_count > 1 ? (
                                <>
                                  <span className='simpletext'>&nbsp;{`${singleFeedData.post_likes[0].liked_by}`} &nbsp;{t("and")}&nbsp;</span> <span className='boldText' /*onClick={this.handleLikePopUp}*/>{`${singleFeedData.post_likes_count - 1} `+t(" others")}</span>
                                </>
                              ) : (
                                <div />
                              )) : null
                        }
                      </div>
                    </LikeCommentCount>
                  ) : null}
                  {singleFeedData?.post_likes.length > 0 ? null : (
                    <div
                      style={{
                        background: "rgba(0,92,135,0.10)",
                        display: "flex",
                        width: "100%",
                        height: "1px",
                      }}
                    ></div>
                  )}
                  <LikeCommentButtonSection commentpopup>
                    <div className="commentSection">
                      <LikeCommentButton>
                        <div className="icon">
                          {singleFeedData?.liked_status ? (
                            <img
                              src={ImageUrl + `/social-feed-reactions/${feed.liked_type}.png`}
                            />
                          ) : <img src={ImageUrl+`/social-feed/like.png`} />}
                        </div>
                        <div className="text">Like</div>
                      </LikeCommentButton>
                    </div>
                    <div className="likeSection">
                      <LikeCommentButton>
                        <div className="icon">
                          {/* <img src={ImageUrl + "/social-feed/comment.png"} /> */}
                          {SocialFeedCommentIcon()}
                        </div>
                        <div className="text">Comment</div>
                      </LikeCommentButton>
                    </div>
                  </LikeCommentButtonSection>
                </PostCommentsWrapper>
              </FeedInformation>
            </div>
          </div>
        </div>
      </ModalContentV1>
    </StyledModal>
  );
};
SocialPostPopup.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  feed: PropTypes.object.isRequired,
  profileImage: PropTypes.object.isRequired,
};
export default SocialPostPopup;
